import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show banner after 3 seconds
      setTimeout(() => setShowBanner(true), 3000);
    };

    window.addEventListener('beforeinstallprompt', handler);

    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setShowBanner(false);
      setDeferredPrompt(null);
    });

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  if (isInstalled || !showBanner) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 rounded-xl p-4 fade-in"
      style={{ background: '#1E1A17', border: '1px solid rgba(200,169,110,0.3)', boxShadow: '0 8px 32px rgba(0,0,0,0.5)' }}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(200,169,110,0.15)' }}>
          <Download className="w-5 h-5" style={{ color: '#C8A96E' }} />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-sm" style={{ fontFamily: 'Outfit', color: '#F5F5F4' }}>Install GrabMillet App</h4>
          <p className="text-xs mt-1" style={{ color: '#A8A29E' }}>Add to your home screen for quick access, works offline too!</p>
          <div className="flex gap-2 mt-3">
            <button
              data-testid="pwa-install-button"
              onClick={handleInstall}
              className="px-4 py-2 rounded-lg text-xs font-semibold transition-all"
              style={{ background: '#C8A96E', color: '#000' }}
            >
              Install App
            </button>
            <button
              data-testid="pwa-dismiss-button"
              onClick={() => setShowBanner(false)}
              className="px-4 py-2 rounded-lg text-xs font-medium transition-all"
              style={{ background: '#2A241F', color: '#A8A29E' }}
            >
              Not now
            </button>
          </div>
        </div>
        <button onClick={() => setShowBanner(false)} className="p-1 flex-shrink-0" style={{ color: '#78716C' }}>
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
